import { BASE_URL } from '../constants/constants';
import axiosRequestInterceptor from '../interceptor/axiosAPIRequestInterceptor';
import { logger } from '../utils/logger';

export const fetchLearningMapDetails = async (userId, subject) => {
	try {
		logger.log('Request body: ', userId, subject);
		//const response = await axiosRequestInterceptor.post(`${DASHBOARD_BASE_URL}/learningMapDetails`,
		const response = await axiosRequestInterceptor.post(`/dashboard/learningMapDetails`, {
			userId: userId,
			subject: subject,
		});
		logger.log(response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchNotebookData = async (userId, topicId, subtopicId, notebookId) => {
	try {
		logger.log('Request body: ', userId, topicId, subtopicId, notebookId);
		//const response = await axiosRequestInterceptor.post(`${DASHBOARD_BASE_URL}/notebookdata`,
		const response = await axiosRequestInterceptor.post(`/dashboard/notebookdata`, {
			userId: userId,
			topicId: topicId,
			subtopicId: subtopicId,
			notebookId: notebookId,
		});
		logger.log('printing api response for fetchNotebookData----> ', response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const fetchNoteBookList = async (userId, identifier, topicId, subtopicId) => {
	try {
		//const response = await axiosRequestInterceptor.post(`${DASHBOARD_BASE_URL}/notebookList`,
		const response = await axiosRequestInterceptor.post(
			`/dashboard/notebookList`,

			{
				userId: userId,
				identifier: identifier,
				topicId: topicId,
				subtopicId: subtopicId,
			}
		);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const getLatestNotebookId = async () => {
	try {
		//const response = await axiosRequestInterceptor.post(`${DASHBOARD_BASE_URL}/latestNotebookId`,
		const response = await axiosRequestInterceptor.post(
			`/dashboard/latestNotebookId`,

			{}
		);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const saveNotebook = async (newNotebook) => {
	let NOTEBOOK_ID = newNotebook.NOTEBOOK_ID;
	let TOPIC_ID = newNotebook.TOPIC_ID;
	let SUBTOPIC_ID = newNotebook.SUBTOPIC_ID;
	let NOTEBOOK_HEADER = newNotebook.NOTEBOOK_HEADER;
	let USER_ID = newNotebook.USER_ID.toString();
	let UPDATED_AT = newNotebook.UPDATED_AT;
	try {
		//const response = await axiosRequestInterceptor.post(`${DASHBOARD_BASE_URL}/saveNotebook`,
		const response = await axiosRequestInterceptor.post(`/dashboard/saveNotebook`, {
			NOTEBOOK_ID: NOTEBOOK_ID,
			NOTEBOOK_HEADER: NOTEBOOK_HEADER,
			TOPIC_ID: TOPIC_ID,
			SUBTOPIC_ID: SUBTOPIC_ID,
			USER_ID: USER_ID,
			UPDATED_AT: UPDATED_AT,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const updateNotebookName = async (notebookId, editName, userId, updatedAt) => {
	//logger.log("editName",editName, "notebookId",notebookId);
	try {
		//const response = await axiosRequestInterceptor.post(`${DASHBOARD_BASE_URL}/updateNotebookName`,
		const response = await axiosRequestInterceptor.post(`/dashboard/updateNotebookName`, {
			notebookId: notebookId,
			notebookName: editName,
			userId: userId.toString(),
			updatedAt: updatedAt,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const getFlashcardList = async (userId, subject) => {
	logger.log('parameters inside getFlashcardList-- userId', userId, 'subject', subject);
	try {
		const response = await axiosRequestInterceptor.post(
			`/dashboard/getTopicList`,
			//const response = await axiosRequestInterceptor.post(`${DASHBOARD_BASE_URL}/getTopicList`,
			{
				userId: userId,
				subject: subject,
			}
		);
		logger.log('response from getFlashcardList', response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};

export const getFlashcardDetails = async (userId, subject, topicId, subtopicId, flashcardId) => {
	try {
		const response = await axiosRequestInterceptor.post(
			`/dashboard/getFlashcardDetails`,
			//const response= await axiosRequestInterceptor.post(`${DASHBOARD_BASE_URL}/getFlashcardDetails`,
			{
				userId: userId,
				subject: subject,
				topicId: topicId,
				subtopicId: subtopicId,
				flashcardId: flashcardId,
			}
		);
		return { success: true, data: response.data };
	} catch (error) {
		return { success: false, error: error.response.data.error };
	}
};

export const getAIContentData = async (formData) => {
	try {
		logger.log('Sending formData to API:', Array.from(formData.entries()));

		const response = await axiosRequestInterceptor.post(`/dashboard/getAIContent`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});

		if (!response.data) {
			throw new Error('No data received from API');
		}

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error in getAIContentData:', error);
		return {
			success: false,
			error: error.response?.data?.error || error.message,
			data: null,
		};
	}
};
export const getConceptQuiz = async (section, topicName, subtopicName) => {
	try {
		// logger.log("Sending formData to API:", Array.from(formData.entries()));

		const response = await axiosRequestInterceptor.post(`/dashboard/getConceptQuiz`, {
			section,
			topicName,
			subtopicName,
		});
		console.log('response: ', response);

		if (!response.data) {
			throw new Error('No data received from API');
		}

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error in getAIContentData:', error);
		return {
			success: false,
			error: error.response?.data?.error || error.message,
			data: null,
		};
	}
};

export const getLatestAIContentId = async () => {
	try {
		const response = await axiosRequestInterceptor.post(`/dashboard/ai-content/latest-id`);
		return response;
	} catch (error) {
		logger.log('Error fetching latest AI content ID:', error);
		throw error;
	}
};

export const saveAIContent = async (newEntry) => {
	try {
		const response = await axiosRequestInterceptor.post(`/dashboard/saveAIContent`, {
			aiContentData: newEntry,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error saving AI content:', error);
		return {
			success: false,
			error: error.response?.data?.error || error.message,
		};
	}
};

export const latestBoxId = async (topicId, subtopicId, notebookId) => {
	try {
		const response = await axiosRequestInterceptor.post(`/dashboard/latest-boxid`, {
			topicId: topicId,
			subtopicId: subtopicId,
			notebookId: notebookId,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error saving AI content:', error);
		return {
			success: false,
			error: error.response?.data?.error || error.message,
		};
	}
};

export const fetchTopicSubtopicNames = async (topicId, subtopicId) => {
	try {
		const response = await axiosRequestInterceptor.post(
			`/dashboard/fetch-topic-subtopic-names`,
			{
				topicId: topicId,
				subtopicId: subtopicId,
			}
		);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error saving AI content:', error);
		return {
			success: false,
			error: error.response?.data?.error || error.message,
		};
	}
};

export const createFlashcard = async (section, topicName, subtopicName) => {
	try {
		const response = await axiosRequestInterceptor.post(`/dashboard/create-flashcard`, {
			section: section,
			topicName: topicName,
			subtopicName: subtopicName,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error creating flashcard', error);
		return {
			success: false,
			error: error.response?.data?.error || error.message,
		};
	}
};

export const getLatestFlashcardId = async () => {
	try {
		const response = await axiosRequestInterceptor.post(`/dashboard/flashcard/latest-id`);
		logger.log('Response from getLatestFlashcardId: ', response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error latest flashcard id:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const saveQuizData = async (quizData) => {
	try {
		const response = await axiosRequestInterceptor.post(`/dashboard/saveConceptQuiz`, {
			quizData,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error saving quiz data:', error);
		return {
			success: false,
			error: error.response?.data?.error || error.message,
		};
	}
};

export const saveUserQuizResponse = async (quizData) => {
	try {
		const response = await axiosRequestInterceptor.post(
			`/dashboard/saveUserQuizResponse`,
			quizData
		);
		return response.data;
	} catch (error) {
		logger.log('Error saving quiz response:', error);
		throw error;
	}
};

export const saveFlashcardData = async (flashcardData) => {
	try {
		const response = await axiosRequestInterceptor.post(`/dashboard/saveFlashcard`, {
			flashcardData,
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error fetching latest flashcard id:', error);
		return { success: false, error: error.response.data.error };
	}
};

export const getAIGeneratedFlashcards = async (formData) => {
	try {
		logger.log('Sending formData to API:', Array.from(formData.entries()));

		const response = await axiosRequestInterceptor.post(
			`/dashboard/getAIGeneratedFlashcards`,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		);

		if (!response.data) {
			throw new Error('No data received from API');
		}

		return { success: true, data: response.data };
	} catch (error) {
		logger.log('Error in getAIContentData:', error);
		return {
			success: false,
			error: error.response?.data?.error || error.message,
			data: null,
		};
	}
};

export const deleteNotebook = async (notebookId) => {
	//logger.log("editName",editName, "notebookId",notebookId);
	try {
		//const response = await axiosRequestInterceptor.post(`${DASHBOARD_BASE_URL}/updateNotebookName`,
		const response = await axiosRequestInterceptor.post(`/dashboard/deleteNotebook`, {
			NOTEBOOK_ID: String(notebookId),
		});
		return { success: true, data: response.data };
	} catch (error) {
		logger.log('error', error);
		return { success: false, error: error.response.data.error };
	}
};
